import { useContext } from 'react';

import './blocking-screen-exit.css';
import { BlockingExitContext } from '../blocking-exit-context';

type Props = {
  placement?: 'inline' | 'header' | 'overlay';
};

/** No MUI, router, auth or payment imports: safe in the earliest React boot surfaces. */
export default function BlockingScreenExit({ placement = 'inline' }: Props) {
  const { enabled, blocked, operatorVerification, request } = useContext(BlockingExitContext);
  if (!enabled) return null;
  const label = operatorVerification ? 'Operator recovery' : 'Exit PointCraft';
  return (
    <div className={`pc-screen-exit pc-screen-exit--${placement}`}>
      <span title={blocked ? 'Finish the active payment before exiting PointCraft.' : label}>
        <button
          type="button"
          className="pc-screen-exit__button"
          aria-label={label}
          disabled={blocked}
          onClick={request}
        >
          {operatorVerification ? 'Operator recovery' : 'Exit'}
        </button>
      </span>
    </div>
  );
}
